module.exports = __webpack_public_path__ + "media/assets/images/smart_working/2-1-ab6fc00322a7d8bba55fae7d444677e1.png";